import React from 'react'


export const socialHistoryData : string[] = 
[
    "Tobacco Use (Current, Former, Never)",
    "Cigarette Smoking (Packs per day, Duration)",
    "Vaping or E-Cigarette Use",
    "Alcohol Use (Frequency, Quantity, Binge Drinking)",
    "History of Alcohol Dependence",
    "Illicit Drug Use (Current or Past)",
    "Cannabis Use",
    "Cocaine Use",
    "Opioid Use (Prescription or Illicit)",
    "Methamphetamine Use",
    "History of Substance Abuse Treatment",
    "Caffeine Consumption (Frequency, Amount)",
    "Dietary Habits (Vegetarian, Vegan, High-Fat Diet, Processed Foods)",
    "Exercise and Physical Activity Level",
    "Sedentary Lifestyle",
    "Occupation and Work Environment",
    "Exposure to Occupational Hazards (Chemicals, Radiation, Noise, Asbestos, etc.)",
    "Night Shift or Irregular Work Schedule",
    "Military Service History",
    "Housing Status (Stable, Homeless, Temporary Shelter)",
    "Living Situation (Alone, With Family, Assisted Living, Nursing Home)",
    "Exposure to Domestic Violence",
    "Exposure to Community Violence",
    "History of Sexual Abuse",
    "History of Physical Abuse",
    "History of Emotional Abuse",
    "Marital Status (Single, Married, Divorced, Widowed)",
    "Sexual Orientation",
    "Gender Identity",
    "Sexual Activity (Number of Partners, Condom Use, STIs)",
    "HIV Risk Factors",
    "Contraception Use",
    "Pregnancy History (Planned, Unplanned, Terminations)",
    "Parental Status (Number of Children, Custody Issues)",
    "Religious and Spiritual Beliefs",
    "Travel History (Recent or Frequent International Travel)",
    "Firearm Ownership and Exposure",
    "Sleep Patterns (Insomnia, Shift Work Disorder, Sleep Apnea)",
    "Stress Levels and Coping Mechanisms",
    "History of Depression or Anxiety",
    "Social Support System (Family, Friends, Support Groups)",
    "Financial Stability",
    "Access to Healthcare (Insurance Status, Barriers to Care)",
    "Health Literacy (Understanding of Medical Conditions and Treatments)",
    "Other (Please specify)"
  ]
  